<h1 mat-dialog-title
    >{{ nurHonorar ? "Honorar " : "Gemeinkosten " }}
    {{ gemeinkosten && gemeinkosten.kosten_id ? "editieren" : "hinzufügen" }}</h1
>
<div mat-dialog-content class="dialog-content">
    <div class="one-row">
        <mat-radio-group
            [formControl]="gemeinkostenTypCtrl"
            (change)="onTypChanged()"
            style="margin-bottom: 24px; align-self: flex-start"
        >
            <mat-radio-button *ngIf="!nurHonorar" [value]="0">Allgemein</mat-radio-button>
            <mat-radio-button [value]="1">Labor</mat-radio-button>
            <mat-radio-button [value]="2">Tierarzt</mat-radio-button>
        </mat-radio-group>
        <span class="spacer"></span>
    </div>

    <div *ngIf="gemeinkostenTypCtrl.value === 2">
        <kiene-autocomplete
            (elementSelected)="setTierarzt($event)"
            [apiUrl]="'tierarzt/'"
            [displayFields]="['titel', 'vorname', 'nachname']"
            [kieneObject]="tierarzt"
            [placeholder]="'Tierarzt (Kopf / Default)'"
        >
        </kiene-autocomplete>
    </div>

    <div class="artikel-with-search">
        <kiene-autocomplete
            (elementSelected)="setMaterial($event)"
            [apiUrl]="'artikel_autocomplete/'"
            [displayField]="'artikel_me'"
            [focus]="false"
            [kieneObject]="material"
            [params]="artikelParams"
            [placeholder]="'Standard-Artikel (für neue Positionen)'"
            [required]="false"
        >
        </kiene-autocomplete>
        <button
            mat-icon-button
            type="button"
            class="artikel-search-btn"
            (click)="openStandardArtikelPicker()"
            [matTooltip]="nurHonorar ? 'Honorar-Artikel suchen / anlegen' : 'Nebenkosten-Artikel suchen / anlegen'"
        >
            <mat-icon>search</mat-icon>
        </button>
    </div>

    <div *ngIf="!nurHonorar">
        <kiene-autocomplete
            (elementSelected)="setLieferant($event)"
            [apiUrl]="'lieferant/'"
            [displayField]="'bezeichnung'"
            [focus]="false"
            [kieneObject]="supplier"
            [params]="lieferantParams"
            [placeholder]="'Lieferant'"
        >
        </kiene-autocomplete>
    </div>

    <div>
        <mat-form-field style="width: 100%">
            <mat-label>Kommentar</mat-label>
            <input [formControl]="kommentarCtrl" matInput />
        </mat-form-field>
    </div>
    <div class="one-row">
        <mat-form-field style="width: 45%">
            <mat-label>Rechnungsnummer</mat-label>
            <input [formControl]="rechnungNummerCtrl" matInput required />
        </mat-form-field>
        <span class="spacer"></span>
        <mat-form-field style="width: 45%">
            <mat-label>Rechnungsdatum</mat-label>
            <input (dateChange)="setDates()" [formControl]="datumCtrl" [matDatepicker]="picker" matInput required />
            <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="one-row">
        <mat-form-field style="width: 45%">
            <mat-label>Leistungsdatum von</mat-label>
            <input [formControl]="leistungsdatumVonCtrl" [matDatepicker]="lstgdatumvon" matInput required />
            <mat-datepicker-toggle [for]="lstgdatumvon" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #lstgdatumvon></mat-datepicker>
        </mat-form-field>
        <span class="spacer"></span>
        <mat-form-field style="width: 45%">
            <mat-label>Leistungsdatum bis</mat-label>
            <input [formControl]="leistungsdatumBisCtrl" [matDatepicker]="lstgdatumbis" matInput />
            <mat-datepicker-toggle [for]="lstgdatumbis" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #lstgdatumbis></mat-datepicker>
        </mat-form-field>
    </div>

    <div class="one-row review-flags" *ngIf="!nurHonorar">
        <mat-checkbox [(ngModel)]="nurGesamtbetrag" (ngModelChange)="onNurGesamtbetragChanged()">
            Nur Gesamtbetrag speichern
        </mat-checkbox>
    </div>

    <ng-container *ngIf="!nurGesamtbetrag">
        <div class="one-row">
            <h3>Positionen</h3>
        </div>
        <p class="hint">
            Je Zeile Artikel und/oder Freitext. Artikel setzt das Aufwandskonto aus dem Stamm (buchungskonto); bei Kfz
            überschreibt Fahrzeug + Kostenart. Kreditor kommt vom Lieferanten.
        </p>

        <div
            cdkDropList
            [cdkDropListData]="gemeinkosten.positionen"
            (cdkDropListDropped)="positionDropped($event)"
            class="position-list"
        >
            <div *ngFor="let pos of gemeinkosten.positionen; let i = index" class="position-row" cdkDrag>
                <div class="one-row pos-artikel">
                    <button
                        type="button"
                        mat-icon-button
                        cdkDragHandle
                        matTooltip="Ziehen zum Sortieren"
                        class="drag-handle"
                    >
                        <mat-icon>drag_indicator</mat-icon>
                    </button>
                    <strong class="pos-nr">{{ i + 1 }}.</strong>
                    <button
                        type="button"
                        mat-icon-button
                        (click)="positionVerschieben(i, -1)"
                        [disabled]="i === 0"
                        matTooltip="Nach oben"
                    >
                        <mat-icon>keyboard_arrow_up</mat-icon>
                    </button>
                    <button
                        type="button"
                        mat-icon-button
                        (click)="positionVerschieben(i, 1)"
                        [disabled]="i >= gemeinkosten.positionen.length - 1"
                        matTooltip="Nach unten"
                    >
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>
                    <div class="field-artikel artikel-with-search">
                        <kiene-autocomplete
                            (elementSelected)="setPositionArtikel(i, $event)"
                            [apiUrl]="'artikel_autocomplete/'"
                            [displayField]="'artikel_me'"
                            [focus]="false"
                            [kieneObject]="positionArtikel[i]"
                            [params]="artikelParams"
                            [placeholder]="'Artikel'"
                            [required]="false"
                        >
                        </kiene-autocomplete>
                        <button
                            mat-icon-button
                            type="button"
                            class="artikel-search-btn"
                            (click)="openPositionArtikelPicker(i)"
                            [matTooltip]="nurHonorar ? 'Honorar-Artikel suchen / anlegen' : 'Nebenkosten-Artikel suchen / anlegen'"
                        >
                            <mat-icon>search</mat-icon>
                        </button>
                    </div>
                    <mat-form-field class="field-text">
                        <mat-label>Freitext</mat-label>
                        <input [(ngModel)]="pos.bezeichnung" matInput placeholder="optional, z.B. Diesel DR-3" />
                    </mat-form-field>
                    <mat-form-field class="field-num">
                        <mat-label>Netto</mat-label>
                        <input [(ngModel)]="pos.kosten_netto" matInput kieneDeNumber inputmode="decimal" />
                        <span matSuffix>&euro;</span>
                    </mat-form-field>
                    <button
                        mat-stroked-button
                        type="button"
                        class="buchungsseite-btn"
                        [class.buchungsseite-h]="pos.buchungsseite === 'H'"
                        (click)="toggleBuchungsseite(i)"
                        [matTooltip]="
                            pos.buchungsseite === 'H' ? 'Haben (Erstattung) – Klick → Soll' : 'Soll (Rechnung) – Klick → Haben'
                        "
                    >
                        {{ pos.buchungsseite === 'H' ? 'H' : 'S' }}
                    </button>
                    <mat-form-field class="field-num">
                        <mat-label>MwSt</mat-label>
                        <mat-select [(ngModel)]="pos.mwstsatz">
                            <mat-option *ngFor="let s of mwstSaetze" [value]="s.value">{{ s.label }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button
                        mat-icon-button
                        type="button"
                        class="mwst-calc-btn"
                        (click)="mwstVomBetragAbziehen(i)"
                        [disabled]="!canMwstVomBetragAbziehen(i)"
                        matTooltip="MwSt abziehen (Brutto → Netto)"
                    >
                        <mat-icon>calculate</mat-icon>
                    </button>
                    <button
                        (click)="positionEntfernen(i)"
                        mat-icon-button
                        type="button"
                        [disabled]="gemeinkosten.positionen.length < 2"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            <div class="one-row pos-fibu" *ngIf="!nurHonorar">
                <div class="field-auto">
                    <kiene-autocomplete
                        (elementSelected)="setPositionFahrzeug(i, $event)"
                        [apiUrl]="'fibu_fahrzeug/'"
                        [displayField]="'anzeige'"
                        [focus]="false"
                        [kieneObject]="positionFahrzeuge[i]"
                        [params]="fahrzeugParams"
                        [placeholder]="'Fahrzeug (optional)'"
                        [required]="false"
                    >
                    </kiene-autocomplete>
                </div>
                <mat-form-field class="field-select">
                    <mat-label>Kostenart</mat-label>
                    <mat-select [(ngModel)]="pos.sachkonto" (selectionChange)="onKostenartChanged(i)">
                        <mat-option [value]="null">–</mat-option>
                        <mat-option *ngFor="let k of kostenarten" [value]="k.value">{{ k.label }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="field-konto">
                    <mat-label>Konto</mat-label>
                    <input [value]="pos.konto_nr || ''" matInput readonly />
                </mat-form-field>
                <div class="field-auto">
                    <kiene-autocomplete
                        (elementSelected)="setPositionTierarzt(i, $event)"
                        [apiUrl]="'tierarzt/'"
                        [displayFields]="['titel', 'vorname', 'nachname']"
                        [focus]="false"
                        [kieneObject]="positionTieraerzte[i]"
                        [placeholder]="'Tierarzt (Zeile)'"
                        [required]="false"
                    >
                    </kiene-autocomplete>
                </div>
            </div>
            <div class="one-row pos-fibu" *ngIf="nurHonorar">
                <div class="field-auto">
                    <kiene-autocomplete
                        (elementSelected)="setPositionHonorarTa(i, $event)"
                        [apiUrl]="'fibu_honorar_ta/'"
                        [displayField]="'anzeige'"
                        [focus]="false"
                        [kieneObject]="positionHonorarTas[i]"
                        [params]="honorarTaParams"
                        [placeholder]="'Honorar-TA'"
                        [required]="false"
                    >
                    </kiene-autocomplete>
                </div>
                <mat-form-field class="field-select">
                    <mat-label>Kostenart</mat-label>
                    <mat-select [(ngModel)]="pos.sachkonto" (selectionChange)="onKostenartChanged(i)">
                        <mat-option [value]="null">–</mat-option>
                        <mat-option *ngFor="let k of kostenarten" [value]="k.value">{{ k.label }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="field-konto">
                    <mat-label>Konto</mat-label>
                    <input [value]="pos.konto_nr || ''" matInput readonly />
                </mat-form-field>
            </div>
            </div>
        </div>

        <div class="one-row" style="margin-top: 8px">
            <span class="spacer"></span>
            <button (click)="positionHinzufuegen()" color="accent" mat-stroked-button type="button">
                <mat-icon>add</mat-icon>
                Position hinzufügen
            </button>
        </div>
    </ng-container>

    <ng-container *ngIf="nurGesamtbetrag">
        <h3>Gesamtbetrag</h3>
        <p class="hint">Eine Position mit Netto/MwSt gesamt. Freitext = Leistungsinhalt (nicht „Gesamtbetrag“).</p>
        <div class="one-row pos-artikel">
            <div class="field-artikel artikel-with-search">
                <kiene-autocomplete
                    (elementSelected)="setGesamtArtikel($event)"
                    [apiUrl]="'artikel_autocomplete/'"
                    [displayField]="'artikel_me'"
                    [focus]="false"
                    [kieneObject]="gesamtArtikel"
                    [params]="artikelParams"
                    [placeholder]="'Artikel'"
                    [required]="false"
                >
                </kiene-autocomplete>
                <button
                    mat-icon-button
                    type="button"
                    class="artikel-search-btn"
                    (click)="openGesamtArtikelPicker()"
                    [matTooltip]="nurHonorar ? 'Honorar-Artikel suchen / anlegen' : 'Nebenkosten-Artikel suchen / anlegen'"
                >
                    <mat-icon>search</mat-icon>
                </button>
            </div>
            <mat-form-field class="field-text">
                <mat-label>Freitext / Leistungsinhalt</mat-label>
                <input [(ngModel)]="gesamtBezeichnung" matInput placeholder="z.B. Tankstelle April" />
            </mat-form-field>
        </div>
        <div class="one-row pos-fibu" *ngIf="!nurHonorar">
            <div class="field-auto">
                <kiene-autocomplete
                    (elementSelected)="setGesamtFahrzeug($event)"
                    [apiUrl]="'fibu_fahrzeug/'"
                    [displayField]="'anzeige'"
                    [focus]="false"
                    [kieneObject]="gesamtFahrzeug"
                    [params]="fahrzeugParams"
                    [placeholder]="'Fahrzeug (optional)'"
                    [required]="false"
                >
                </kiene-autocomplete>
            </div>
            <mat-form-field class="field-select">
                <mat-label>Kostenart</mat-label>
                <mat-select [(ngModel)]="gesamtSachkonto" (selectionChange)="onGesamtKostenartChanged()">
                    <mat-option [value]="null">–</mat-option>
                    <mat-option *ngFor="let k of kostenarten" [value]="k.value">{{ k.label }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="field-konto">
                <mat-label>Konto</mat-label>
                <input [value]="gesamtKontoNr || ''" matInput readonly />
            </mat-form-field>
            <div class="field-auto">
                <kiene-autocomplete
                    (elementSelected)="setGesamtTierarzt($event)"
                    [apiUrl]="'tierarzt/'"
                    [displayFields]="['titel', 'vorname', 'nachname']"
                    [focus]="false"
                    [kieneObject]="gesamtTierarzt"
                    [placeholder]="'Tierarzt (Zeile)'"
                    [required]="false"
                >
                </kiene-autocomplete>
            </div>
        </div>
        <div class="one-row pos-fibu" *ngIf="nurHonorar">
            <div class="field-auto">
                <kiene-autocomplete
                    (elementSelected)="setGesamtHonorarTa($event)"
                    [apiUrl]="'fibu_honorar_ta/'"
                    [displayField]="'anzeige'"
                    [focus]="false"
                    [kieneObject]="gesamtHonorarTa"
                    [params]="honorarTaParams"
                    [placeholder]="'Honorar-TA'"
                    [required]="false"
                >
                </kiene-autocomplete>
            </div>
            <mat-form-field class="field-select">
                <mat-label>Kostenart</mat-label>
                <mat-select [(ngModel)]="gesamtSachkonto" (selectionChange)="onGesamtKostenartChanged()">
                    <mat-option [value]="null">–</mat-option>
                    <mat-option *ngFor="let k of kostenarten" [value]="k.value">{{ k.label }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="field-konto">
                <mat-label>Konto</mat-label>
                <input [value]="gesamtKontoNr || ''" matInput readonly />
            </mat-form-field>
        </div>
    </ng-container>

    <div class="totals" *ngIf="gemeinkosten.positionen?.length || nurGesamtbetrag">
        <ng-container *ngIf="!nurGesamtbetrag">
            <div class="totals-row">
                <span>Netto gesamt</span>
                <strong>{{ sumNetto | number: '1.2-2' }} €</strong>
            </div>
            <div class="totals-row">
                <span>MwSt gesamt</span>
                <strong>{{ sumMwst | number: '1.2-2' }} €</strong>
            </div>
            <div class="totals-row totals-brutto">
                <span>Brutto gesamt</span>
                <strong>{{ sumBrutto | number: '1.2-2' }} €</strong>
            </div>
        </ng-container>
        <ng-container *ngIf="nurGesamtbetrag">
            <div class="one-row totals-edit">
                <mat-form-field class="field-num-wide">
                    <mat-label>Netto gesamt</mat-label>
                    <input
                        [(ngModel)]="gesamtNetto"
                        (ngModelChange)="onGesamtNettoChanged()"
                        matInput
                        kieneDeNumber
                        inputmode="decimal"
                    />
                    <span matSuffix>&euro;</span>
                </mat-form-field>
                <mat-form-field class="field-mwst">
                    <mat-label>MwSt</mat-label>
                    <mat-select [(ngModel)]="gesamtMwstsatz" (ngModelChange)="onGesamtMwstsatzChanged()">
                        <mat-option *ngFor="let s of mwstSaetze" [value]="s.value">{{ s.label }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <button
                    mat-icon-button
                    type="button"
                    class="mwst-calc-btn"
                    (click)="mwstVomGesamtbetragAbziehen()"
                    [disabled]="!canMwstVomGesamtbetragAbziehen()"
                    matTooltip="MwSt abziehen (Brutto → Netto)"
                >
                    <mat-icon>calculate</mat-icon>
                </button>
                <mat-form-field class="field-num-wide">
                    <mat-label>MwSt gesamt</mat-label>
                    <input
                        [(ngModel)]="gesamtMwstEuro"
                        (ngModelChange)="onGesamtMwstEuroChanged()"
                        matInput
                        kieneDeNumber
                        inputmode="decimal"
                    />
                    <span matSuffix>&euro;</span>
                </mat-form-field>
            </div>
            <div class="totals-row totals-brutto brutto-edit-row">
                <span>Brutto gesamt</span>
                <div class="brutto-edit">
                    <button
                        mat-icon-button
                        type="button"
                        (click)="adjustBruttoCent(-1)"
                        matTooltip="Brutto −1 Cent (MwSt anpassen)"
                    >
                        <mat-icon>remove</mat-icon>
                    </button>
                    <mat-form-field class="field-brutto">
                        <input
                            [ngModel]="gesamtBrutto"
                            (ngModelChange)="onGesamtBruttoChanged($event)"
                            matInput
                            kieneDeNumber
                            inputmode="decimal"
                        />
                        <span matSuffix>&euro;</span>
                    </mat-form-field>
                    <button
                        mat-icon-button
                        type="button"
                        (click)="adjustBruttoCent(1)"
                        matTooltip="Brutto +1 Cent (MwSt anpassen)"
                    >
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </ng-container>
    </div>

    <button (click)="openFileSelector()" color="accent" mat-flat-button type="button"
        >Rechnung als PDF hinzuf&uuml;gen</button
    >
    <input #fileSelector (change)="handleFiles($event)" accept="application/pdf" style="display: none" type="file" />

    <div *ngIf="filesToUpload.length > 0">
        <mat-list>
            <h4 mat-subheader>Dateien</h4>
            <div *ngFor="let file of filesToUpload; let i = index" style="width: 100%">
                <div class="one-row" style="margin-bottom: 12px">
                    <mat-icon mat-list-icon style="width: 70px">insert_drive_file</mat-icon>
                    <div style="min-width: 40%">{{ file?.name }}</div>
                    <mat-icon *ngIf="filesUploadStatus[i] == 1" color="primary">check</mat-icon>
                    <mat-icon *ngIf="filesUploadStatus[i] == 2" color="warn">warning</mat-icon>
                    <span class="spacer"></span>
                    <mat-progress-spinner [diameter]="30" [value]="filesProgressValues[i]" mode="determinate">
                    </mat-progress-spinner>
                </div>
            </div>
        </mat-list>
    </div>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button (click)="close()" mat-button type="button">Abbrechen</button>
    <button (click)="save()" [disabled]="!isValid()" color="accent" mat-flat-button type="button"
        >{{ gemeinkosten && gemeinkosten.kosten_id ? "editieren" : "hinzufügen" }}
    </button>
</div>
